import { I18n } from "i18n-js";
import en from "./generated/en.json";

const i18n = new I18n(en);

export default i18n;
